export const sanitizeUriString = (uri: string | null): string | null => {
  if (!uri) return null;

  const trimmed = uri.trim();
  const lower = trimmed.toLowerCase();

  // Blokir protokol berbahaya
  const unsafeProtocols = ["javascript:", "data:", "vbscript:"];
  for (const protocol of unsafeProtocols) {
    if (lower.startsWith(protocol)) return null;
  }

  try {
    const parsed = new URL(trimmed, window.location.origin);
    if (!parsed.pathname.startsWith("/")) return null;
    return parsed.pathname;
  } catch {
    return null;
  }
};
